<template>
  <v-row no-gutters>
    <NewLayoutSelect :selectedSection="selectedSection"/>
    <NewLayoutDialog :selectedSection="selectedSection"/>
    <NewLayoutConfig :selectedSection="selectedSection"/>

    <Expansion v-model="styleExpansion.common" :verticalExpansion="false" defaultClass="pt-4">
      <template slot="default">
        <ExpandedIcon :isExpanded="styleExpansion.common"/>
        <span class="pl-2 _subtitleFormFont">
          <b>Personalizar estilo</b>
        </span>
      </template>

      <template slot="expanded">
        <v-row no-gutters class="pt-4">
          <v-col cols="6" class="_pr-">
            <TextField 
              v-model="layout.width"
              label="Largura ingresso"
              type="number"
              :minValueForNumber="width"
              appendIcon="fa-solid fa-xmark"
              appendIconTooltip="Resetar para largura padrão"
              @appendClick="handleReset('width')"
            />
          </v-col>

          <v-col cols="6" class="_pl-">
            <TextField 
              v-model="layout.featuredWidth"
              label="Largura ingresso destaque"
              type="number"
              :minValueForNumber="featuredWidth"
              smallFontLabel
              appendIcon="fa-solid fa-xmark"
              appendIconTooltip="Resetar para largura padrão"
              @appendClick="handleReset('featuredWidth')"              
            />            
          </v-col>  

          <v-col cols="6" class="_pr- _pt">
            <ColorPickerV2 title="Cor principal" :colorSelected="layout" type="accentColor1" defaultColor="#0A9AED"/> 
          </v-col>

          <v-col cols="6" class="_pl- _pt">
            <ColorPickerV2 title="Cor secundária" :colorSelected="layout" type="accentColor2" defaultColor="#055387"/> 
          </v-col>

          <v-col cols="6" class="_pt _pr-">
            <ColorPickerV2 title="Cor de fundo" :colorSelected="layout" type="bgColor" defaultColor="#FFFFFF"/> 
          </v-col>

          <v-col cols="6"></v-col>   

          <v-col cols="6" class="pt-5 _pr-">
            <ColorPickerV2 title="Cor fundo item incluso" :colorSelected="layout.checkColor1" type="bgChecked" defaultColor="#0A9AED" smallFont/> 
          </v-col>    

          <v-col cols="6" class="pt-5 _pl-">
            <ColorPickerV2 title="Cor ícone item incluso" :colorSelected="layout.checkColor1" type="colorChecked" defaultColor="#0A9AED" smallFont/> 
          </v-col>  

          <v-col cols="6" class="_pt _pr-">
            <ColorPickerV2 title="Cor fundo item não incluso" :colorSelected="layout.checkColor1" type="bgNotChecked" defaultColor="#F7F8F8" smallFont/> 
          </v-col>    

          <v-col cols="6" class="_pt _pl-">
            <ColorPickerV2 title="Cor ícone item não incluso" :colorSelected="layout.checkColor1" type="colorNotChecked" defaultColor="#D7D9E0" smallFont/> 
          </v-col>    
        </v-row>
      </template>
    </Expansion>   
  </v-row>
</template>

<script>
import ColorPickerV2 from '../../../../_v2/ui/ColorPickerV2.vue'
import Expansion from '../../../../_v2/ui/Expansion.vue'
import TextField from '../../../../_v2/ui/TextField.vue'
import ExpandedIcon from '../../../../_v2/utils/ExpandedIcon.vue'
import NewLayoutSelect from './newLayoutsSelect.vue'
import NewLayoutDialog from './newLayoutsDialog.vue'
import NewLayoutConfig from './newLayoutsConfig.vue'
import { TICKETS_GET_DEFAULT_WIDTH } from '../../../../../schemas/sections'

export default {
  name: 'newLayout1',
  components: {ColorPickerV2, NewLayoutSelect, NewLayoutDialog, Expansion, ExpandedIcon, NewLayoutConfig, TextField},
  props: {
    selectedSection: {type: Object, required: true}
  },
  computed: {
    layout () {
      return this.selectedSection.layoutStyle.newLayout1
    }
  },
  
  mounted () {
    setTimeout(() => { this.styleExpansion = {common: false, highlight: false} })
  },

  data: () => ({
    styleExpansion: {common: true, highlight: true},
    width: TICKETS_GET_DEFAULT_WIDTH('newLayout1').width,
    featuredWidth: TICKETS_GET_DEFAULT_WIDTH('newLayout1').featuredWidth
  }),

  methods: {
    handleReset (type) {
      if (type === 'width') this.layout.width = this.width
      if (type === 'featuredWidth') this.layout.featuredWidth = this.featuredWidth
    }
  }    
}
</script>

<style scoped>
</style>